import React, {useEffect, useState} from 'react';
import NotificationListHeader from "../../components/notificationListHeader/NotificationListHeader";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {Col, Divider, Flex, Skeleton} from "antd";
import NotificationItem from "../../components/notificationItem/NotificationItem";
import {getNotification} from "../../actions/Notification.action";
import {NotificationListProps} from "../../models";
import CategoryCard from "../../../dashboard/components/categoryList/CategoryCard";
import {EmptyMessage} from "../../../../shared";
import RequestCard from "../../../cartable/components/sentRequests/sentRequestCard";

const NotificationList = ({getNotification} : NotificationListProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [notifications, setNotifications] = useState<any[]>([]);
    const _getNotification = () => {
        setLoading(true)
        getNotification()
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    setNotifications(data.payload.data);

                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getNotification();
    }, []);
    return (
        <Flex vertical gap={"large"}>
            <NotificationListHeader/>
            {(notifications?.length === 0 && !loading) && <EmptyMessage message={"اعلانی در حال حاضر موجود نیست !"}/>}
            {loading ?<Flex vertical gap={"large"}>
                    <Skeleton paragraph={{ rows: 2 }}  round active />
                    <Skeleton paragraph={{ rows: 2 }}  round active />
                    <Skeleton paragraph={{ rows: 2 }}  round active />

                </Flex> :
                notifications.map((item, index) => (
                    <NotificationItem key={index} onUpdateHandle={() =>_getNotification() } index={index} data={item} />
                ))
            }

        </Flex>
    );
};


export default connect(null, {getNotification})(
    withRouter(NotificationList)
);